import React,{useState,useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import {Link,Redirect} from 'react-router-dom'
import MuiAlert from '@material-ui/lab/Alert';
import CircularProgress  from '@material-ui/core/CircularProgress'
import Backdrop from '@material-ui/core/Backdrop';
import {useHistory } from "react-router-dom";
import Navbar from './Navbar'

import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" to="mailto:jomonfullstack@gmail.com">
        Messenger@ developed by Jomon
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}


const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(12),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border:'1px solid #3f51b5',
    padding:theme.spacing(5),
    width:'100%',
    borderRadius:'4px'
    
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: '#3f51b5',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  alert:{
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
}));

export  function Login() {
  const [formValue, setValue] = useState({username:'',password:''});
  const [response,setStatus]  = useState({status:'',message:''})
  const [loading,setLoading]  = useState(false)
  const history = useHistory();
  const classes = useStyles();
  useEffect(() => {
    if(localStorage.getItem('token')){
      history.push("/chat");
    }
    // Update the document title using the browser API
    customValidation();
    
    
},[]);
 const customValidation = (e) =>{
   ValidatorForm.addValidationRule('minLength', (value) => {
    if (value.trim().length<5) {
        return false;
    }
    
    //setValue({id:val});
    return true
});
 }
  
  const onHandleChange = 
    (e) => {
          console.log(formValue);
          var id  = e.target.id;
          var val = e.target.value;
          
        setValue({username:id=='username'?val:formValue.username,password:id=='password'?val:formValue['password']});
        //setValue({id:val});
        return true;
      }
  const onhandleSubmit =(e,props)=> {
    setLoading(true);
    const data = new FormData(e.target);
     const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({"username":data.get('username'),"password":data.get('password')})
    };
    fetch('https://mernsocketmessenger.herokuapp.com/user/login', requestOptions)
        .then(response => {return response.json();})
        .then(data => {
          console.log(data);
          if(data.message=='Success'){
            //this.props.history.push('/chat')
            localStorage.setItem('token', data.token);
            localStorage.setItem('username', data.username);
            history.push("/chat");
          }
          setLoading(false)
          setStatus({message:data.message,status:data.status})
        }).catch(data=>{
          console.log('ssss');
          console.log(data);
        });
    return;
  }    
  return (
    
     
    
    <Container component="main" maxWidth="xs"> 
    <Navbar/>
      <CssBaseline />
      <div className={classes.paper}>
      
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon  />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <div className={classes.alert}>
          <Alert style={{display:response.message.length>0?'flex':'none'}} severity={response.status!=200?"error":"success"}>{response.message}</Alert>
        </div>
        <ValidatorForm className={classes.form} onSubmit={onhandleSubmit} noValidate>
        
          <Backdrop className={classes.backdrop} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>        
          <TextValidator
          
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="User Name"
            name="username"
            autoComplete="username"
            autoFocus
            type="text"
            onChange={onHandleChange}
            value={formValue['username']}
            validators={['required','minLength']}
            errorMessages={['this field is required','Please enter a valid username']}
          /> 
          <TextValidator
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onChange={onHandleChange}
            value={formValue['password']}
            validators={['required','minLength']}
            errorMessages={['this field is required', 'password is not valid']}
          />
          
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Sign In
          </Button>
          <Grid container>
            
            <Grid item>
              <Link to="/signup" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </ValidatorForm>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}

